<template>
  <div id="app">
    <LoginModal></LoginModal>
    <ForgetModal></ForgetModal>
    <router-view class="route-appssssssss"></router-view>
  </div>
</template>
<script>
import LoginModal from '@/components/common/loginModal'
import ForgetModal from '@/components/common/forgetModal'
export default {
  components: {
    LoginModal,
    ForgetModal
  }
}
</script>
<style lang="less">
html,body {
  // min-width: 1300px;
}
#app {
  font-family: "Microsoft YaHei", "SF Pro Text", Arial, Helvetica , Sans-Serif,serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  overflow: auto;
  letter-spacing: 1px;
  text-indent: 1px;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
